export default __webpack_public_path__ + "static/media/blinds.bd6ad650.svg";